<template>
  <main class="h-screen flex flex-col">
    <header class="bg-background p-4">
      <div class="flex items-center justify-between">
        <HeaderPanel />
        <div class="flex items-center gap-4"></div>
      </div>
    </header>
    <div class="px-4">
      <AiAuditTabCard :value="tabIndex" @change="tabIndex = $event" />
    </div>
    <el-scrollbar class="flex-1 scroll-bar">
      <EventList v-if="tabIndex === 0" />
      <FeedbackList v-else-if="tabIndex === 1" />
      <AIAgentList v-else-if="tabIndex === 2" />
      <ModelList v-else-if="tabIndex === 3" />
    </el-scrollbar>
  </main>
</template>

<script>
import HeaderPanel from "./HeaderPanel.vue";
import AiAuditTabCard from "./AiAuditTabCard.vue";
import EventList from "./EventList.vue";
import FeedbackList from "./FeedbackList.vue";
import AIAgentList from "./AIAgentList.vue";
import ModelList from "./ModelList.vue";

export default {
  name: "AiAuditLogs",
  components: {
    HeaderPanel,
    AiAuditTabCard,
    EventList,
    FeedbackList,
    AIAgentList,
    ModelList,
  },
  data() {
    return {
      tabIndex: 0,
    };
  },
};
</script>
